import * as firebase from 'firebase/firebase-browser';
import { firebaseConfig } from './config';

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseAuth = firebaseApp.auth();
export const firebaseDb = firebaseApp.database();



/** WEBPACK FOOTER **
 ** ./src/core/firebase/firebase.js
 **/